module.exports = __webpack_public_path__ + "5ff494baa4faa6cc140cdc1d344c4e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/configured-vehicle-selector/background-image.png
// module id = 1720
// module chunks = 0 1